export default __webpack_public_path__ + "static/media/img_circular.dbf25540.png";